/*
 * nc-preset-models — the preset models of the photo step of <nc-fitting-room> (B3, DP-1 b decided by Javi on 2026-10-27; images and
 * provenance in docs/normcore-modelos-sinteticos.md). Four AI-generated fictional people a user without a photo can try looks on. The
 * markup ("Elige un modelo", a radiogroup above the drop area of the "Tu foto" dialog) and its copy come from snippets/nc-fitting-room.liquid
 * (locales sections.fitting_room.models / model_names / model_kinds; files from the host section's `photo_models` setting). This file
 * holds the pure rules and the two side effects the component must not own itself: reading the model's theme asset as a File and the
 * per-browser memory of the last model used. Choosing a model then follows the SAME path as an own photo in nc-fitting-room.js
 * (createUpload purpose 'avatar' -> validateAvatar -> pendingUpload -> "Usar" / "Usar y crear"): with the real gateway it is an avatar
 * row like any photo, so the render does not change.
 */
(function (root) {
  var KEY = 'nc-fr-photo-model';

  function storage() {
    try { return root && root.localStorage ? root.localStorage : null; } catch (e) { return null; }
  }

  // the model id remembered in this browser; a private window or blocked storage answers null (the dialog then preselects nothing)
  function readRemembered(store) {
    var s = store === undefined ? storage() : store;
    try { return (s && s.getItem(KEY)) || null; } catch (e) { return null; }
  }

  function remember(id, store) {
    var s = store === undefined ? storage() : store;
    try { if (s) { if (id) s.setItem(KEY, id); else s.removeItem(KEY); } } catch (e) { /* storage blocked: nothing to remember */ }
  }

  // which tile is checked when the dialog opens and whether "Usar" may upload it (armed). It never uploads by itself.
  //   a photo in use: only the model that photo came from is checked, unarmed ("Cambiar foto" never replaces it on its own)
  //   no photo: the remembered model, else the first one when CREAR opened the dialog (the shortest path to a result), else none
  function pick(ids, opts) {
    var o = opts || {};
    var list = Array.isArray(ids) ? ids : [];
    if (!list.length) return { id: null, armed: false };
    if (o.hasPhoto) return { id: o.current && list.indexOf(o.current) >= 0 ? o.current : null, armed: false };
    if (o.remembered && list.indexOf(o.remembered) >= 0) return { id: o.remembered, armed: true };
    if (o.reason === 'generate') return { id: list[0], armed: true };
    return { id: null, armed: false };
  }

  // radiogroup keys: arrows move and wrap, Home / End jump to the extremes; -1 for any other key
  function step(index, key, n) {
    if (!(n > 0)) return -1;
    var i = index >= 0 && index < n ? index : 0;
    if (key === 'Home') return 0;
    if (key === 'End') return n - 1;
    if (key === 'ArrowRight' || key === 'ArrowDown') return index < 0 ? 0 : (i + 1) % n;
    if (key === 'ArrowLeft' || key === 'ArrowUp') return index < 0 ? n - 1 : (i - 1 + n) % n;
    return -1;
  }

  // the name the model is uploaded with: the last path segment of its asset URL, without query or hash
  function fileName(url, fallback) {
    var path = String(url || '').split('#')[0].split('?')[0];
    var name = path.slice(path.lastIndexOf('/') + 1);
    try { name = decodeURIComponent(name); } catch (e) { /* keep it raw */ }
    return name || fallback || 'model';
  }

  // the model's theme asset (same origin on the storefront) as a File, ready for gateway.createUpload({ purpose: 'avatar', file })
  function loadFile(src, fallbackName) {
    if (!src || typeof root.fetch !== 'function' || typeof root.File !== 'function') return Promise.reject(new Error('unavailable'));
    return root.fetch(src, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('model ' + r.status);
      return r.blob();
    }).then(function (blob) {
      var type = blob.type === 'image/png' ? 'image/png' : 'image/jpeg';
      return new root.File([blob], fileName(src, fallbackName), { type: type });
    });
  }

  var api = { KEY: KEY, readRemembered: readRemembered, remember: remember, pick: pick, step: step, fileName: fileName, loadFile: loadFile };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.NcPresetModels = api;
})(typeof window !== 'undefined' ? window : globalThis);
